<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import { dynamicTime } from 'shared/helpers/timeHelper';

export default {
  components: {
    Thumbnail,
  },
  props: {
    notificationItem: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    sender() {
      return this.notificationItem.primary_actor?.meta?.sender || {};
    },
    conversationLabel() {
      const { primary_actor: primaryActor } = this.notificationItem;
      return primaryActor
        ? `#${primaryActor.id}`
        : this.$t('NOTIFICATIONS_PAGE.DELETE_TITLE');
    },
  },
  methods: {
    dynamicTime,
    onClickOpenNotification() {
      this.$emit('openNotification', this.notificationItem);
    },
  },
};
</script>

<template>
  <woot-button
    size="expanded"
    color-scheme="secondary"
    variant="link"
    class="w-full"
    @click="onClickOpenNotification()"
  >
    <div
      class="flex items-start w-full gap-3 px-3 py-2.5 text-left rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700/50"
    >
      <Thumbnail
        :src="sender.thumbnail || ''"
        :username="sender.name || conversationLabel"
        size="32px"
      />
      <div class="flex flex-col flex-1 min-w-0 gap-0.5">
        <div class="flex items-center justify-between gap-2">
          <span
            class="text-sm font-semibold truncate text-slate-800 dark:text-slate-100"
          >
            {{ sender.name || conversationLabel }}
          </span>
          <span
            class="flex-shrink-0 text-xxs text-slate-500 dark:text-slate-400"
          >
            {{ dynamicTime(notificationItem.last_activity_at) }}
          </span>
        </div>
        <div class="flex items-center gap-1.5 text-xxs">
          <span class="font-semibold text-slate-600 dark:text-slate-300">
            {{ conversationLabel }}
          </span>
          <span
            class="px-1.5 py-px rounded text-woot-600 dark:text-woot-300 bg-woot-50 dark:bg-woot-800"
          >
            {{
              $t(
                `NOTIFICATIONS_PAGE.TYPE_LABEL.${notificationItem.notification_type}`
              )
            }}
          </span>
        </div>
        <span class="text-xs truncate text-slate-500 dark:text-slate-400">
          {{ notificationItem.push_message_title }}
        </span>
      </div>
      <span
        v-if="!notificationItem.read_at"
        class="flex-shrink-0 w-2 h-2 mt-1.5 rounded-full bg-woot-500"
      />
    </div>
  </woot-button>
</template>
